import React, { useState } from 'react';
import {
  useDisclosure,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  useColorModeValue,
  Icon,
  Divider,
  Box,
  AbsoluteCenter,
  Text,
  Flex,
  Select
} from '@chakra-ui/react';
import { MdEditDocument } from 'react-icons/md';
import { MdCancel, MdCheckCircle, MdOutlineError } from 'react-icons/md';
import IncidentService from '../../../../../services/IncidentService';

export default function AlertDialogExample(props) {

  const [vehicle, setVehicle] = useState("")
  const [driver, setDriver] = useState("")
  const [precheckRecord, setPrecheckRecord] = useState("")
  const [incidentStatus,setIncidentStatus] = useState("")

  const token = localStorage.getItem('token');
  const loadData = async (e) => {
    e.preventDefault();
    onOpen();
    setSelectedChecklistDetails(e.currentTarget.parentElement.id);


  };
  const textColor = useColorModeValue('secondaryGray.900', 'white');



  const setSelectedChecklistDetails = async (id) => {
    try {
      const response = await IncidentService.getIncident(token, id);
      const vehicle = {
        vinNumber: response.data.object.vehicle.vinNumber,
        make: response.data.object.vehicle.make,
        model: response.data.object.vehicle.model,
        vehicleCategory: response.data.object.vehicle.vehicleCategory.category,
        vehicleType: response.data.object.vehicle.vehicleType.type,
        rego: response.data.object.vehicle.registration,
        year: response.data.object.vehicle.year
      };
      const driver = {
        name: response.data.object.user.preferredName,
        email: response.data.object.user.emailAddress,
        mobile: response.data.object.user.mobileNumber
      };

      let incidentLevel = '';

      if (response.data.object.incidentLevel === 'DO_NOT_OPERATE_MACHINERY') {
        incidentLevel = 'Do Not Operate Machinery';
      } else if (response.data.object.incidentLevel === 'REPORT_AND_PROCEED_WITH_CAUTION') {
        incidentLevel = 'Report & Proceed with Caution';
      } else if (response.data.object.incidentLevel === 'SUCCESS') {
        incidentLevel = 'Success';
      }


      const precheckRecord = {
        status: incidentLevel,
        description: response.data.object.description
      };
      setVehicle(vehicle)
      setDriver(driver)
      setPrecheckRecord(precheckRecord)
      setIncidentStatus(response.data.object.incidentStatus)

    } catch (error) {
      console.log(error);
    }
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const iconColor = useColorModeValue('brand.500', 'white');
  const handleStatus = ({target:{value}}) => setIncidentStatus(value)

  return (
    <>
      <Button onClick={(e) => (loadData(e))}>
        <Icon
          as={MdEditDocument}
          color={iconColor}
          w="24px"
          h="24px"
        />
      </Button>

      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size='xl'
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Incident Checklist Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={10}>
            <Box position='relative' padding='4'>
              <Divider />
              <AbsoluteCenter bg='white' px='4'>
                Vehicle Details
              </AbsoluteCenter>
            </Box>
            <FormControl>
              <FormLabel><Text as='b'>Rego</Text> : {vehicle.rego}</FormLabel>
              <FormLabel><Text as='b'>Vin Number</Text> : {vehicle.vinNumber}</FormLabel>
              <FormLabel><Text as='b'>Make</Text> : {vehicle.make}</FormLabel>
              <FormLabel><Text as='b'>Model</Text> : {vehicle.model}</FormLabel>
              <FormLabel><Text as='b'>Year</Text> : {vehicle.year}</FormLabel>
              <FormLabel><Text as='b'>Category</Text>  : {vehicle.vehicleCategory}</FormLabel>
              <FormLabel><Text as='b'>Type</Text> : {vehicle.vehicleType}</FormLabel>
            </FormControl>

            <Box position='relative' padding='4'>
              <Divider />
              <AbsoluteCenter bg='white' px='4'>
                Driver Details
              </AbsoluteCenter>
            </Box>
            <FormControl>
              <FormLabel><Text as='b'>Driver</Text> : {driver.name}</FormLabel>
              <FormLabel><Text as='b'>Email</Text> : {driver.email}</FormLabel>
              <FormLabel><Text as='b'>Mobile</Text> : {driver.mobile}</FormLabel>
            </FormControl>

            <Box position='relative' padding='8'>
              <Divider />
              <AbsoluteCenter bg='white' px='1'>
                Incident Details
              </AbsoluteCenter>
            </Box>
            <FormControl>
              <FormLabel>
                <Flex align="center">
                  <Text as='b'>Status : </Text>
                  <Icon
                    w="24px"
                    h="24px"
                    me="5px"
                    color={
                      precheckRecord.status === 'Success'
                        ? 'green.500'
                        : precheckRecord.status === 'Do Not Operate Machinery'
                          ? 'red.500'
                          : precheckRecord.status === 'Report & Proceed with Caution'
                            ? 'orange.500'
                            : null
                    }
                    as={
                      precheckRecord.status === 'Success'
                        ? MdCheckCircle
                        : precheckRecord.status === 'Do Not Operate Machinery'
                          ? MdCancel
                          : precheckRecord.status === 'Report & Proceed with Caution'
                            ? MdOutlineError
                            : null
                    }
                  />
                  <Text color={textColor} fontSize="sm" fontWeight="700">
                    {precheckRecord.status}
                  </Text>
                </Flex>
              </FormLabel>
              <FormLabel><Text as='b'>Description</Text> : {precheckRecord.description}</FormLabel>
              <FormControl mt={4}>
                <FormLabel>Status</FormLabel>
                <Select onChange={handleStatus} value={incidentStatus}>
                  <option value="OPEN">Open</option>
                  <option value="INACTIVE">Inactive</option>
                </Select>
              </FormControl>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} >
              Update Incident
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
